import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { useState, useEffect } from 'react';
export var useActiveElement = function useActiveElement() {
  var _useState = useState(document.activeElement),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var handleFocusIn = function handleFocusIn() {
    setActive(document.activeElement);
  };

  useEffect(function () {
    document.addEventListener('focusin', handleFocusIn);
    return function () {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, []);
  return active;
};